module.exports = __webpack_public_path__ + "static/0048-ef9b7dc35491e625b3903c8ec10d1a49.png";